import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import store from "../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../actions/authentication-actions";
import associateServices from "../services";
import io from "socket.io-client";
import GLOBAL_ACTIONS from "../actions/global-actions";
import MainListeners from "./listeners";
import {Routes} from "./routes";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import RakebackToast from "../components/toast/RakebackToast";
import WithdrawDepositToast from "../components/toast/WithdrawToast";
import InformationToast from "../components/toast/InformationToast";
import ReloadToast from "../components/toast/ReloadToast";
import RainToast from "../components/toast/RainToast";
import StringHelper from "../helpers/string-helper";
import {Helmet, HelmetProvider} from 'react-helmet-async';
import Seo from "./seo";
import BeforeLoading from "../components/before-loading";
import RankUpdateToast from "../components/toast/RankUpdateToast";
import StyleHelper from "../helpers/styleHelper";
import LanguageRedirect from "./LanguageRedirect";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import Maintenance from "./maintenance";
import DataActions from "../actions/data-actions";
import {useBroadcastChannelListener} from "../hooks/useBroadcastChannel";
import axios from "axios";

let types1 = [];

const MainRouter = () => {
    useBroadcastChannelListener();

    const [loading, setLoading] = useState(true)
    const [loadingConf, setLoadingConf] = useState(true)
    const [showMaintenance, setShowMaintenance] = useState(false)
    const {activeLanguage, theme, languages} = useSelector(state => state.globalReducer)
    const {scriptsR} = useSelector(state => state.dataReducer)
    const {authenticated, user} = useSelector(state => state.authenticationReducer)
    const [seo, setSeo] = useState({})
    const [configuration, setConfiguration] = useState({})
    const [favicon, setFavicon] = useState(null)
    const [cssFiles, setCssFiles] = useState([])
    const [scripts, setScripts] = useState([])
    const {t} = useTranslation()

    useEffect(() => {
        if (favicon) {
            const faviconElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
            faviconElement.type = 'image/x-icon';
            faviconElement.rel = 'shortcut icon';
            faviconElement.href = favicon;

            // Append the link element to the head if not already present
            document.getElementsByTagName('head')[0].appendChild(faviconElement);
        }
    }, [favicon]);

    useEffect(() => {
        // console.log('authenticated = ', authenticated)
        const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))
        const handleCurrencies = response => store.dispatch(AUTHENTICATION_ACTIONS.setCurrenciesAction(response?.data || []))
        const getUserWallets = () => associateServices.getWallets({}).then(handleUserWallets)
        const getCurrencies = () => associateServices.getCurrencies({}).then(handleCurrencies)


        if (authenticated) {
            getCurrencies()
            getUserWallets();
        }
    }, [authenticated])

    const getCssFiles = theme => {
        if (!theme || types1[theme])
            return true

        types1[theme] = 1
        associateServices.getCssFiles({theme}).then(res => setCssFiles(res?.data || []))
        associateServices.getScripts({theme}).then(res => {
            setScripts(res?.data || [])
        })
    }
    // const getScripts = theme => {
    //     return true
    //     if (!theme || scriptsR[theme])
    //         return true
    //     associateServices.getScripts({theme})
    //         .then(res => {
    //             store.dispatch(DataActions.setScripts({
    //                 data: res?.data || [],
    //                 type: theme
    //             }))
    //
    //         })
    //         .catch(error => {
    //             console.error('Error loading the scripts:', error);
    //         });
    // }

    useEffect(() => {
        if (theme) {
            // getScripts(theme)
            getCssFiles(theme)
        }
    }, [theme])


    const setThemeByConf = (data) => {
        let themeValue = localStorage?.getItem('theme')
        if (!data?.has_themes) {
            themeValue = data?.theme
        } else {
            if (!['light', 'dark'].includes(themeValue))
                themeValue = data?.theme
        }

        getCssFiles(themeValue)
        StyleHelper.setThemeButtons(data);

        store.dispatch(GLOBAL_ACTIONS.setThemeAction(themeValue))
        document.documentElement.setAttribute('data-bs-theme', themeValue);


    }

    // useEffect(() => {
    //
    //
    //     if (Array.isArray(scripts)) {
    //         try {
    //             scripts?.forEach(scriptItem => {
    //
    //
    //                 // console.log(scriptItem)
    //                 // Create a temporary div to extract the HTML content
    //                 const tempDiv = document.createElement('div');
    //                 tempDiv.innerHTML = scriptItem?.script;
    //
    //                 // Extract the div element (add to body)
    //                 const divElement = tempDiv.querySelector('div');
    //                 if (divElement)
    //                     document.body.appendChild(divElement);
    //
    //                 // Extract the script element (add to head)
    //                 const scriptElement = tempDiv.querySelector('script');
    //                 if (scriptElement) {
    //                     const newScript = document.createElement('script');
    //                     newScript.type = 'text/javascript';
    //                     newScript.nonce = "randomNonce"; // Set the nonce attribute
    //                     newScript.innerHTML = scriptElement.innerHTML;
    //
    //                     // newScript.addEventListener('load', handleScriptOnLoad);
    //                     document.head.appendChild(newScript);
    //                 } else {
    //                     console.log('SCRIPT NOT FOUND')
    //                 }
    //             });
    //         } catch (e) {
    //             console.error(e)
    //         }
    //     } else {
    //         console.error('Invalid script data');
    //     }
    //
    //
    // }, [scripts])


    useEffect(() => {
        if (!Array.isArray(scripts)) {
            console.error('Invalid script data');
            return;
        }

        const appendedElements = [];

        scripts.forEach((scriptItem, index) => {
            try {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = scriptItem?.script || '';

                // Append <div> content to body (if exists)
                const divElement = tempDiv.querySelector('div');
                if (divElement) {
                    document.body.appendChild(divElement);
                    appendedElements.push(divElement);
                }

                // Append <script> content to head
                const scriptElement = tempDiv.querySelector('script');
                if (scriptElement) {
                    const newScript = document.createElement('script');
                    newScript.type = 'text/javascript';
                    newScript.nonce = 'randomNonce'; // Change this if using CSP

                    if (scriptElement.src) {
                        // External script
                        newScript.src = scriptElement.src;
                        newScript.async = true;
                        newScript.onload = () => console.log(`Script ${index} loaded`);
                        newScript.onerror = () => console.error(`Script ${index} failed to load`);
                    } else {
                        // Inline script
                        newScript.textContent = scriptElement.textContent;
                    }

                    document.head.appendChild(newScript);
                    appendedElements.push(newScript);
                } else {
                    console.warn(`SCRIPT tag not found in item ${index}`);
                }
            } catch (e) {
                console.error(`Error processing script ${index}:`, e);
            }
        });

        // Cleanup on unmount or when scripts change
        return () => {
            appendedElements.forEach(el => el.parentNode?.removeChild(el));
        };
    }, [scripts]);


    useEffect(() => {

        associateServices.getConfiguration({
            lang: activeLanguage?.key || 'en'
        })
            .then(res => {

                // if (res?.data?.data?.is_maintenance) {
                if (false) {

                    setShowMaintenance(true)
                    setConfiguration(res?.data?.data)

                    // TODO SHOW ERROR PAGE !

                    document.documentElement.style.setProperty('--tf-active', res?.data?.data?.color);
                    document.documentElement.style.setProperty('--tf-skeleton', StringHelper.hexToRgba(res?.data?.data?.bg_dark, .4));
                    document.documentElement.style.setProperty('--tf-active-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.2));
                    document.documentElement.style.setProperty('--tf-border', StringHelper.hexToRgba(res?.data?.data?.color, .05));
                    document.documentElement.style.setProperty('--tf-borderhover', StringHelper.hexToRgba(res?.data?.data?.color, .2));
                    document.documentElement.style.setProperty('--tf-active-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.08));
                    document.documentElement.style.setProperty('--tf-border-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.4));
                    document.documentElement.style.setProperty('--tf-btncolor', res?.data?.data?.color);
                    document.documentElement.style.setProperty('--tf-before-color', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .8)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, .1)} 100%)`);
                    // linear-gradient(to right, #093028 0%, #237A57 51%, #093028 100%);
                    document.documentElement.style.setProperty('--tf-cool-button', `linear-gradient(to right, ${StringHelper.adjustBrightness(res?.data?.data?.color, -80)} 0%,${StringHelper.adjustBrightness(res?.data?.data?.color, -20)} 51%, ${StringHelper.adjustBrightness(res?.data?.data?.color, 10)} 100%)`);

                    localStorage.setItem('--tf-logo', `${res?.data?.data?.logo_white}`)
                    document.documentElement.style.setProperty('--tf-logo', `url(${res?.data?.data?.logo_white})`);

                    document.documentElement.style.setProperty('--tf-logo2', `url(${res?.data?.data?.logo_dark})`);
                    document.documentElement.style.setProperty('--tf-bg', `${res?.data?.data?.bg_dark}`);
                    document.documentElement.style.setProperty('--tf-bg2', `${res?.data?.data?.bg2_dark}`);

                    document.documentElement.style.setProperty('--mini-logo', `url(${res?.data?.data?.mini_logo})`);

                    document.documentElement.style.setProperty('--tf-card-bg', `url(${res?.data?.data?.slider_bg})`);

                    document.documentElement.style.setProperty('--tf-logo-s', `url(${res?.data?.data?.mini_logo})`);
                    document.documentElement.style.setProperty('--tf-btn', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .2)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, 0.05)} 100%)`);
                    document.documentElement.style.setProperty('--tf-btn2', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .2)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, 0.02)} 100%)`);
                    document.documentElement.style.setProperty('--tf-vip', `linear-gradient(90deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .02)}  0%, ${StringHelper.hexToRgba(res?.data?.data?.color, .04)}  33%, ${StringHelper.hexToRgba(res?.data?.data?.color, .06)}  66%, ${StringHelper.hexToRgba(res?.data?.data?.color, .08)}  100%)`);

                    setLoadingConf(false)

                } else {

                    if (res?.data?.data?.languages?.length <= 0)
                        return toast.error('No language content found !')

                    setConfiguration(res?.data?.data)
                    setSeo(res?.data?.seo)

                    setThemeByConf(res?.data?.data)
                    store.dispatch(GLOBAL_ACTIONS.setConfigurationAction(res?.data?.data || {}))

                    const pathSegments = location.pathname.split('/');
                    const urlLanguage = pathSegments[1] || null // Assuming the language is the first segment

                    if (urlLanguage) {
                        if (res?.data?.data?.languages?.find(oo => urlLanguage === oo.key)) {
                            // If the URL language is supported, change the language in i18next
                            store.dispatch(GLOBAL_ACTIONS.setActiveLanguage(urlLanguage))
                        } else {
                            store.dispatch(GLOBAL_ACTIONS.setActiveLanguage('en'))
                        }
                    } else {
                        store.dispatch(GLOBAL_ACTIONS.setActiveLanguage(/\d/.test(window.location.hostname) ? 'tr' : 'en'))
                    }


                    // const localLanguage = localStorage.getItem('language');
                    // if (localLanguage)
                    //     store.dispatch(GLOBAL_ACTIONS.setActiveLanguage(localLanguage))
                    // else {
                    //     store.dispatch(GLOBAL_ACTIONS.setActiveLanguage(/\d/.test(window.location.hostname) ? 'tr' : 'en'))
                    // }

                    localStorage.setItem('w_id', res?.data?.data?.w_id)
                    localStorage.setItem('w-secret', res?.data?.data?.secret)
                    localStorage.setItem('base:color', res?.data?.data?.color)

                    setFavicon(res?.data?.data?.favicon)

                    document.documentElement.style.setProperty('--tf-active', res?.data?.data?.color);
                    document.documentElement.style.setProperty('--tf-skeleton', StringHelper.hexToRgba(res?.data?.data?.bg_light, .4));
                    document.documentElement.style.setProperty('--tf-active-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.2));
                    document.documentElement.style.setProperty('--tf-border', StringHelper.hexToRgba(res?.data?.data?.color, .05));
                    document.documentElement.style.setProperty('--tf-borderhover', StringHelper.hexToRgba(res?.data?.data?.color, .2));
                    document.documentElement.style.setProperty('--tf-active-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.08));
                    document.documentElement.style.setProperty('--tf-border-opacity', StringHelper.hexToRgba(res?.data?.data?.color, 0.4));
                    document.documentElement.style.setProperty('--tf-btncolor', res?.data?.data?.color);
                    document.documentElement.style.setProperty('--tf-before-color', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .8)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, .1)} 100%)`);
                    // linear-gradient(to right, #093028 0%, #237A57 51%, #093028 100%);
                    document.documentElement.style.setProperty('--tf-cool-button', `linear-gradient(to right, ${StringHelper.adjustBrightness(res?.data?.data?.color, -80)} 0%,${StringHelper.adjustBrightness(res?.data?.data?.color, -20)} 51%, ${StringHelper.adjustBrightness(res?.data?.data?.color, 10)} 100%)`);

                    localStorage.setItem('--tf-logo', `${res?.data?.data?.logo_white}`)
                    document.documentElement.style.setProperty('--tf-logo', `url(${res?.data?.data?.logo_white})`);

                    document.documentElement.style.setProperty('--tf-logo2', `url(${res?.data?.data?.logo_dark})`);
                    document.documentElement.style.setProperty('--tf-bg', `${res?.data?.data?.bg_light}`);
                    document.documentElement.style.setProperty('--tf-bg2', `${res?.data?.data?.bg2_light}`);

                    document.documentElement.style.setProperty('--mini-logo', `url(${res?.data?.data?.mini_logo})`);

                    document.documentElement.style.setProperty('--tf-card-bg', `url(${res?.data?.data?.slider_bg})`);

                    document.documentElement.style.setProperty('--tf-logo-s', `url(${res?.data?.data?.mini_logo})`);
                    document.documentElement.style.setProperty('--tf-btn', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .2)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, 0.05)} 100%)`);
                    document.documentElement.style.setProperty('--tf-btn2', `linear-gradient(180deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .2)} 0%, ${StringHelper.hexToRgba(res?.data?.data?.color, 0.02)} 100%)`);
                    document.documentElement.style.setProperty('--tf-vip', `linear-gradient(90deg, ${StringHelper.hexToRgba(res?.data?.data?.color, .02)}  0%, ${StringHelper.hexToRgba(res?.data?.data?.color, .04)}  33%, ${StringHelper.hexToRgba(res?.data?.data?.color, .06)}  66%, ${StringHelper.hexToRgba(res?.data?.data?.color, .08)}  100%)`);


                    setLoadingConf(res?.status !== 200)
                    // setTimeout(() => setLoadingConf(res?.status !== 200), 500)
                }

            })


    }, [activeLanguage?.key])

    useEffect(() => {
        if (!loadingConf) {

            associateServices.getGameProviders({})
                .then(res => store.dispatch(GLOBAL_ACTIONS.setGameProviders(res?.data || [])))

            associateServices.getNetworks({})
                .then(res => store.dispatch(GLOBAL_ACTIONS.setNetworks(res?.data || [])))


            const handleLocalTokenResponse = response => response?.status === 200 ? store.dispatch(AUTHENTICATION_ACTIONS.setUserToken(response?.data)) : store.dispatch(AUTHENTICATION_ACTIONS.setUserLogOut(null))
            const checkForToken = async () => {
                associateServices.user({}).then(handleLocalTokenResponse)
            }


            // const gameSelectedCurrency = localStorage.getItem('gameSelectedCurrency');
            // if (gameSelectedCurrency)
            //     store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency(gameSelectedCurrency))


            const selectedFiat = localStorage.getItem('selectedFiat');
            if (selectedFiat && selectedFiat !== 'null' && selectedFiat !== 'undefined' && selectedFiat !== '')
                store.dispatch(AUTHENTICATION_ACTIONS.setSelectedFiatAction(selectedFiat))


            const hideZeroBalances = localStorage.getItem('hideZeroBalances');
            if (hideZeroBalances && (hideZeroBalances === 'true' || hideZeroBalances === true))
                store.dispatch(AUTHENTICATION_ACTIONS.setHideZeroBalancesAction(true))


            const localToken = localStorage.getItem('bearer');
            if (localToken)
                checkForToken().then(r => setTimeout(() => setLoading(false), 500))
            else
                setLoading(false)
        }
    }, [loadingConf])

    useEffect(() => {
        if (!loading) {
            try {
                if (user?.ws) {
                    makeTcpSocketConnection(user.id, user?.ws)
                } else {
                    makeTcpSocketConnection(user.id, null)
                }

            } catch (e) {
                console.error('error => ', e)
            }
        }
    }, [user?.ws, loading])

    const {i18n} = useTranslation();
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams();
    useEffect(() => {
        // Supported languages
        if (!loadingConf) {

            // Extract the language from the URL path
            const pathSegments = location.pathname.split('/');
            const urlLanguage = pathSegments[1] || null // Assuming the language is the first segment

            const currentPathname = window.location.pathname;
            const searchParams = window.location.search;

// Remove any existing language segment from the pathname (/tr or /en)
            const sanitizedPathname = currentPathname.replace(/^\/(tr|en)/, '')

            if (urlLanguage) {
                if (languages.find(oo => urlLanguage === oo.key)) {
                    // If the URL language is supported, change the language in i18next
                    store.dispatch(GLOBAL_ACTIONS.setActiveLanguage(urlLanguage))
                } else {
                    // If the language is not supported, redirect to the default language (e.g., 'en')
                    navigate(`/en${sanitizedPathname}${searchParams}`); // Remove the language segment from the pathname
                }
            } else {
                if (window.location.hostname === 'tempo365.com')
                    navigate(`/en${sanitizedPathname}${searchParams}`)
                else
                    navigate(/\d/.test(window.location.hostname)
                        ? `/tr${sanitizedPathname}${searchParams}`
                        : `/en${sanitizedPathname}${searchParams}`);
            }


        }

    }, [navigate, location.pathname, i18n, loadingConf]);


    // useEffect(() => {
    //     if (user?.ws) {
    //         window.intercomSettings = {
    //             api_base: "https://api-iam.intercom.io",
    //             app_id: "gz3613t1",
    //             name: user.username,
    //             email: user.email,
    //             user_id: user.id,
    //             created_at: user.registration,
    //             hide_default_launcher: true
    //
    //         };
    //     } else {
    //         window.intercomSettings = {
    //             api_base: "https://api-iam.intercom.io",
    //             app_id: "gz3613t1",
    //             hide_default_launcher: true
    //
    //         };
    //     }
    // }, [window?.Intercom, user.id])

    const handleBalanceUpdate = e => store.dispatch(AUTHENTICATION_ACTIONS.updateWalletBalance(JSON.parse(e)))
    const handleTurnOverPercentage = e => store.dispatch(AUTHENTICATION_ACTIONS.updateUserPercentage(e))

    const handleRankUpdate = e => {

        const newRank = JSON.parse(e)

        console.log('newRank = ', newRank)
        return toast(<RankUpdateToast
            title={t('socket-notifications.vip-updated-title')}
            message={t('socket-notifications.vip-updated-desc', {
                state: newRank?.rank,
            })}

            icon={newRank?.icon}
        />)
    }

    const handleRakeback = e => {
        const data = JSON.parse(e)

        console.log('RAKEBACK DATA = ', data)

        if (data?.amount && !data?.currency)
            toast.error(t(`socket-notifications.${data.message}`, {
                amount: data.amount,
            }))

        if (data?.amount && data?.currency)
            toast(<RakebackToast code={data?.currency || data?.code} amount={data.amount}/>)
        // toast.success(t(`socket-notifications.${data.message}`, {
        //     amount: data.amount,
        //     code: data.currency,
        // }))
    }
    const handleTip = e => {
        const data = JSON.parse(e)

        if (!data?.status)
            toast.error(t(`socket-notifications.${data.data}`))

        if (data?.amount && data?.currency)
            toast.success(t(`socket-notifications.${data.message}`, {
                amount: data.amount,
                code: data.currency,
            }))
    }
    const handleNotification = e => {
        const data = JSON.parse(e)

        if (data?.message === 'withdraw-approved' || data?.message === 'withdraw-completed') {
            toast(<WithdrawDepositToast
                amount={data.amount}
                code={data.code}
                title={t(`api-notifications.${data.message}`)}
            />)
        } else if (data?.message === 'deposit-approved' || data?.message === 'deposit-completed') {
            toast(<WithdrawDepositToast
                amount={data.amount}
                code={data.code}
                title={t(`api-notifications.${data.message}`)}
            />)
        } else if (data?.message === 'reload-taken-successfully'
            || data?.message === 'reload-redeemed-successfully') {
            toast(<ReloadToast
                amount={data.amount}
                code={data.code}
                title={t(`notifications.${data.message}`)}
            />)

        } else if (data?.message === 'rain-received') {
            toast(<RainToast
                amount={data.amount}
                code={data.code}
                title={t(`notifications.${data.message}`)}
            />)

        } else if (
            data?.message === 'you-need-to-have-minimum-500-usd-wager-for-chat' ||
            data?.message === 'you-are-muted-in-chat' ||
            data?.message === 'chat-slow-down' ||
            data?.message === 'you-are-not-allowed-to-send-message-in-chat') {
            toast(<InformationToast icon={'ti-x'}
                                    title={t(`general.error`)}
                                    message={t(`socket-notifications.${data.message}`)}/>)
        } else if (
            data?.message === 'tip-taken-successfully'
            || data?.message === 'tip-sent-successfully'
        )
            toast.success(t(`socket-notifications.${data.message}`, {
                amount: data.amount,
                currency: data.code,
                code: data.code,
            }))


        // notification

        // store.dispatch(GLOBAL_ACTIONS.appendNotificationsAction(data))
    }

    const makeTcpSocketConnection = (customerID, accessToken) => {

        // console.log('makeTcpSocketConnection = ', customerID, '=>', accessToken)
        window?.tcpSocket?.removeAllListeners();
        window?.tcpSocket?.disconnect();


        window.tcpSocket = io('https://hub.ebetlab.com', {
            'transports': ['websocket', 'polling'],
            upgrade: false,
            auth: {
                token: accessToken,
            },
            // withCredentials: true
        });

        window.tcpSocket?.on('connect', () => {
            // console.log('WS CONNECTED = ', `CUSTOMER~${customerID}`)
            if (customerID)
                window?.tcpSocket?.emit('join', `CUSTOMER~${customerID}`)

            window.tcpSocket.off('balance:update').on('balance:update', handleBalanceUpdate)
            window.tcpSocket.off('vip-percent').on('vip-percent', handleTurnOverPercentage)
            window.tcpSocket.off('rank').on('rank', handleRankUpdate)
            window.tcpSocket.off('rakeback').on('rakeback', handleRakeback)
            window.tcpSocket.off('notification').on('notification', handleNotification)
            window.tcpSocket.off('tip').on('tip', handleTip)
        });

        window?.tcpSocket?.on("connect_error", (err) => {
            console.error('connect_error = ', err)
        });
    }

    // const [resizing, setResizing] = useState(false)
    // useEffect(() => {
    //     if (!agent?.isMobile) {
    //         const handleResize = () => {
    //             // Update the state with the new window width
    //             if (resizing)
    //                 return false
    //
    //             setResizing(true);
    //
    //             setTimeout(() => setResizing(favicon), 3000)
    //         };
    //
    //         // Add the event listener
    //         window.addEventListener('resize', handleResize);
    //
    //         // Cleanup the event listener on component unmount
    //         return () => {
    //             window.removeEventListener('resize', handleResize);
    //         };
    //     }
    // }, [agent?.isMobile]);


    if (loading || loadingConf)
        return <BeforeLoading/>

    if (showMaintenance)
        return <Maintenance configuration={configuration}/>


    return <HelmetProvider>
        <Helmet>
            {
                cssFiles?.map(css => <link key={css.link} id={css.link} rel="stylesheet" href={css.link}/>)
            }
        </Helmet>
        <Seo configuration={configuration} seo={seo}/>
        {/*<LanguageRedirect/>*/}
        <Routes isAuthorized={true}/>
        <MainListeners/>
    </HelmetProvider>


}


export default React.memo(MainRouter)
